module.exports = __webpack_public_path__ + "static/media/03_tn.85b69b13.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/thumbnails/03_tn.jpg
// module id = 433
// module chunks = 0